import http from "../http-common";

class CandidateDataService {
  getAllUser() {
    // Matches your backend: router.get('/mediusers/list', ...)
    return http.get("/v1/mediadmin/mediusers/list");
  }

  create(data) {
    return http.post("/v1/mediadmin/mediusers/add", data);
  }

  updateStatus(id, data) {
    return http.put(`/v1/mediadmin/mediusers/update/${id}`, data);
  }

  deleteAdmin(id) {
    return http.delete(`/v1/mediadmin/mediusers/delete/${id}`);
  }
}

export default new CandidateDataService();